import type { Locale } from "@bloom/types";

const COOKIE_NAME = "bloom-locale";
const SUB_COOKIE_NAME = "bloom-sub-lang";

export function detectLocaleFromHeader(acceptLanguage: string | null | undefined): Locale {
  if (!acceptLanguage) return "en";
  const first = acceptLanguage.split(",")[0]?.trim().toLowerCase() ?? "";
  if (first.startsWith("th")) return "th";
  return "en";
}

export function readLocaleCookie(cookieString: string | null | undefined): Locale | null {
  if (!cookieString) return null;
  for (const part of cookieString.split(";")) {
    const [k, v] = part.trim().split("=");
    if (k === COOKIE_NAME && (v === "th" || v === "en")) return v;
  }
  return null;
}

export function readSubtitleLanguageCookie(cookieString: string | null | undefined): string | null {
  if (!cookieString) return null;
  for (const part of cookieString.split(";")) {
    const [k, v] = part.trim().split("=");
    if (k === SUB_COOKIE_NAME && v) return v;
  }
  return null;
}

export const LOCALE_COOKIE_NAME = COOKIE_NAME;
export const SUBTITLE_COOKIE_NAME = SUB_COOKIE_NAME;
